import { Subheader } from '@cambridgeassessment/cambridge-ui';
import Logo from '@cambridgeassessment/cambridge-ui/build/components/General/Logo/Logo';
import { useMountEffect } from 'lib-browser';
import React from 'react';
import { useHistory } from 'react-router';
import { StyledContainer, StyledHeadline } from './DowntimePage.styles';

const DowntimePage: React.FC = () => {
  const history = useHistory();

  useMountEffect(() => {
    history.block();
  });
  return (
    <div>
      <StyledContainer>
        <Logo type='caPress' width='241' height='42' />
        <StyledHeadline>The system is unavailable at the moment</StyledHeadline>
        <Subheader>We are working on it. Please check back soon.</Subheader>
      </StyledContainer>
    </div>
  );
};

export default DowntimePage;
